<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Deactivate Client?</p>
      </header>
      <section class="modal-card-body">
        <div class="pa-lg has-text-centered">
          Are you sure you want to deactivate this client?
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <b-button @click="$parent.close()">Close</b-button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="!ready || saving"
        >Suspend Client</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api']),
    ready () {
      return true
    }
  },
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/clients/' + this.client.id + '/status'
      const body = {
        status: 'suspended'
      }
      this.$http.put(endpoint, body).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Client updated.' })
        this.$emit('client:saved')
        this.$parent.close()
      }).catch(error => {
        if ('response' in error && error.response.status === 422) {
          this.errors = error.response.data.errors
        }
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  }
}
</script>
